module.exports = __webpack_public_path__ + "img/contacts_phone_big1.9c284e63.svg";